import { DocumentStatus } from './types';

/** Only DRAFT documents can be edited in billing workflows (SHER-423). */
export function isBillEditable(status: DocumentStatus): boolean {
    return status === DocumentStatus.DRAFT;
}

export function isBillCancelled(status: DocumentStatus): boolean {
    return status === DocumentStatus.CANCELLED;
}
